import { render, staticRenderFns } from "./ContactEditAutofillModal.vue?vue&type=template&id=87adf826"
import script from "./ContactEditAutofillModal.vue?vue&type=script&lang=ts"
export * from "./ContactEditAutofillModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87adf826')) {
      api.createRecord('87adf826', component.options)
    } else {
      api.reload('87adf826', component.options)
    }
    module.hot.accept("./ContactEditAutofillModal.vue?vue&type=template&id=87adf826", function () {
      api.rerender('87adf826', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditAutofillModal.vue"
export default component.exports